// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__25GkC","summary":"CartItem_summary__3ihDT","price":"CartItem_price__2KcCi","amount":"CartItem_amount__1n3XF","actions":"CartItem_actions__3miiV"};